import React from 'react';
import { Users } from 'lucide-react';
export function TrustBadge() {
  return <div className="inline-flex items-center gap-2 bg-[#E8F3EF] text-[#2D4A3E] px-4 py-2 rounded-full mb-6" data-id="element-1">
      <Users className="w-4 h-4 text-[#7CAA98]" data-id="element-2" />
      <span className="text-sm font-medium" data-id="element-3">
        15.000+ hondenbezitters gingen je voor
      </span>
    </div>;
}